import React from "react";
import ImageUploadField from "./ImageUploadField";

// Icons offered for quick facts (Bootstrap Icons, already loaded on the public site)
export const FACT_ICONS = [
    ["bi-cake2-fill", "Birthday"],
    ["bi-mortarboard-fill", "Education"],
    ["bi-geo-alt-fill", "Location"],
    ["bi-clock-history", "Career"],
    ["bi-briefcase-fill", "Work"],
    ["bi-people-fill", "People"],
    ["bi-house-fill", "Home"],
    ["bi-info-circle-fill", "General"],
];

const emptyStat = { value: "", label: "", label_np: "" };
const emptyFact = { icon: "bi-info-circle-fill", label: "", label_np: "", value: "", value_np: "" };

function Field({ label, children, col = "col-md-6" }) {
    return (
        <div className={col}>
            <label className="form-label small">{label}</label>
            {children}
        </div>
    );
}

export default function PoliticalProfileTab({ form, set, personaluid, stats, setStats, facts, setFacts }) {
    const inp = (k, extra = {}) => (
        <input className="form-control form-control-sm" value={form[k] || ""} onChange={(e) => set(k, e.target.value)} {...extra} />
    );
    const updRow = (list, setList, i, key, val) => {
        const c = [...list];
        c[i] = { ...c[i], [key]: val };
        setList(c);
    };
    const removeAt = (list, setList, i) => setList(list.filter((_, idx) => idx !== i));

    return (
        <div>
            <div className="card shadow-sm mb-3">
                <div className="card-header bg-light fw-semibold">Profile Information</div>
                <div className="card-body">
                    <div className="row g-3">
                        <Field label="Full Name *">{inp("name", { placeholder: "e.g. Rajendra Singh" })}</Field>
                        <Field label="पूरा नाम (Nepali)">{inp("name_np", { placeholder: "जस्तै: राजेन्द्र सिंह" })}</Field>

                        <Field label="Position / Title">{inp("position_title", { placeholder: "e.g. Member of Parliament" })}</Field>
                        <Field label="पद (Nepali)">{inp("position_title_np", { placeholder: "जस्तै: सांसद" })}</Field>

                        <Field label="Political Party">{inp("party", { placeholder: "e.g. Nepali Congress" })}</Field>
                        <Field label="पार्टी (Nepali)">{inp("party_np")}</Field>

                        <Field label="Tagline">{inp("tagline", { placeholder: "e.g. Serving the people" })}</Field>
                        <Field label="ट्यागलाइन (Nepali)">{inp("tagline_np")}</Field>

                        <Field label="Phone">{inp("phone")}</Field>
                        <Field label="Email">{inp("email", { type: "email" })}</Field>

                        <Field label="Address / Constituency">{inp("address", { placeholder: "e.g. Kathmandu District" })}</Field>
                        <Field label="Website URL">{inp("website", { placeholder: "https://example.com" })}</Field>

                        <Field label="Profile Photo">
                            <ImageUploadField value={form.photo} onChange={(v) => set("photo", v)} purpose="logo" personaluid={personaluid} placeholder="Upload your photo" />
                        </Field>
                        <Field label="Cover Image">
                            <ImageUploadField value={form.cover} onChange={(v) => set("cover", v)} purpose="cover" personaluid={personaluid} placeholder="Upload cover image" />
                        </Field>
                        <Field label="Party Logo / Flag (shown on the party ribbon)">
                            <ImageUploadField value={form.party_logo} onChange={(v) => set("party_logo", v)} purpose="logo" personaluid={personaluid} placeholder="Upload party logo" />
                        </Field>
                    </div>
                </div>
            </div>

            <div className="card shadow-sm mb-3">
                <div className="card-header bg-light fw-semibold">About / Biography</div>
                <div className="card-body">
                    <label className="form-label small">English</label>
                    <textarea rows="5" className="form-control form-control-sm mb-3"
                        placeholder="Write your biography, background, and political career..."
                        value={form.about || ""} onChange={(e) => set("about", e.target.value)} />
                    <label className="form-label small">नेपाली (Nepali)</label>
                    <textarea rows="5" className="form-control form-control-sm"
                        placeholder="जीवनी, पृष्ठभूमि र राजनीतिक यात्रा..."
                        value={form.about_np || ""} onChange={(e) => set("about_np", e.target.value)} />
                    <small className="form-text text-muted mt-1">
                        Visitors switch language with the English / नेपाली button on your site. Anything left blank in Nepali falls back to English.
                    </small>
                </div>
            </div>

            <div className="card shadow-sm mb-3">
                <div className="card-header bg-light fw-semibold d-flex justify-content-between align-items-center">
                    <span>Hero Stats <small className="text-muted fw-normal">(up to 4 counters, e.g. “42 · Years in Politics”)</small></span>
                    <button type="button" className="btn btn-sm btn-outline-primary" disabled={stats.length >= 4}
                        onClick={() => setStats([...stats, { ...emptyStat }])}>
                        <i className="bi bi-plus-lg me-1" />Add Stat
                    </button>
                </div>
                <div className="card-body">
                    {stats.length === 0 ? <p className="text-muted mb-0">No stats added.</p> : stats.map((s, i) => (
                        <div className="row g-2 align-items-end mb-2" key={i}>
                            <div className="col-md-2">
                                <label className="form-label small text-muted">Value</label>
                                <input className="form-control form-control-sm" placeholder="42 or 75%" value={s.value} onChange={(e) => updRow(stats, setStats, i, "value", e.target.value)} />
                            </div>
                            <div className="col-md-4">
                                <label className="form-label small text-muted">Label</label>
                                <input className="form-control form-control-sm" placeholder="Years in Politics" value={s.label} onChange={(e) => updRow(stats, setStats, i, "label", e.target.value)} />
                            </div>
                            <div className="col-md-5">
                                <label className="form-label small text-muted">लेबल (Nepali)</label>
                                <input className="form-control form-control-sm" value={s.label_np} onChange={(e) => updRow(stats, setStats, i, "label_np", e.target.value)} />
                            </div>
                            <div className="col-md-1">
                                <button type="button" className="btn btn-sm btn-outline-danger w-100" onClick={() => removeAt(stats, setStats, i)}><i className="bi bi-trash" /></button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div className="card shadow-sm mb-3">
                <div className="card-header bg-light fw-semibold d-flex justify-content-between align-items-center">
                    <span>Quick Facts <small className="text-muted fw-normal">(date of birth, education, career…)</small></span>
                    <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => setFacts([...facts, { ...emptyFact }])}>
                        <i className="bi bi-plus-lg me-1" />Add Fact
                    </button>
                </div>
                <div className="card-body">
                    <p className="text-muted small">Position, party, constituency, phone and email are added automatically from the fields above.</p>
                    {facts.length === 0 ? <p className="text-muted mb-0">No extra facts added.</p> : facts.map((f, i) => (
                        <div className="row g-2 align-items-end mb-3 pb-3 border-bottom" key={i}>
                            <div className="col-md-2">
                                <label className="form-label small text-muted">Icon</label>
                                <select className="form-select form-select-sm" value={f.icon} onChange={(e) => updRow(facts, setFacts, i, "icon", e.target.value)}>
                                    {FACT_ICONS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                                </select>
                            </div>
                            <div className="col-md-5">
                                <label className="form-label small text-muted">Label / लेबल</label>
                                <div className="input-group input-group-sm">
                                    <input className="form-control" placeholder="Date of Birth" value={f.label} onChange={(e) => updRow(facts, setFacts, i, "label", e.target.value)} />
                                    <input className="form-control" placeholder="जन्म मिति" value={f.label_np} onChange={(e) => updRow(facts, setFacts, i, "label_np", e.target.value)} />
                                </div>
                            </div>
                            <div className="col-md-4">
                                <label className="form-label small text-muted">Value / मान</label>
                                <div className="input-group input-group-sm">
                                    <input className="form-control" placeholder="February 22, 1952" value={f.value} onChange={(e) => updRow(facts, setFacts, i, "value", e.target.value)} />
                                    <input className="form-control" placeholder="नेपालीमा" value={f.value_np} onChange={(e) => updRow(facts, setFacts, i, "value_np", e.target.value)} />
                                </div>
                            </div>
                            <div className="col-md-1">
                                <button type="button" className="btn btn-sm btn-outline-danger w-100" onClick={() => removeAt(facts, setFacts, i)}><i className="bi bi-trash" /></button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

        </div>
    );
}